import React, { useState, useEffect } from "react";
import UseWindowSize from "../components/UseWindowSize";
import { defaultURL } from "../data/DataMetatags";
import NextHead from "../components/Seo/NextHead";
import Layout from "../components/Layout";
import ShopOffline from "../components/Shop/ShopOffline";
import { SeoTextShopOffline } from "../components/Shop/SEOText";
import { fetchOfflineShop } from "../utils/gateway";
import { ShopOfflineBreadcrumb } from "../data/DataBreadcrumb";
import BreadcrumbComponent from "../components/UserInterface/BreadcrumbComponent";
import { belanjaDitokoMeta } from "../data/DataMetatags";
import BannerComponent from "../components/UserInterface/BannerComponent";
import BannerImage from "../../public/static/images/jpg/Belanja_di_Toko_Website-Banner.jpg";
import BannerMiniImage from "../../public/static/images/jpg/Belanja_di_Toko_Mini_Web-Banner.jpg";
import { GACustomEvent } from "src/utils/analytics";

const belanjaDiToko = ({
  asPath,
  pageTitle,
  descriptionSEO,
  dataOfflineShop
}) => {
  const breadcrumb = [
    {
      "@type": "ListItem",
      position: "1",
      item: {
        "@id": defaultURL,
        name: "Home"
      }
    },
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": defaultURL + asPath,
        name: pageTitle
      }
    }
  ];

  const [winSize, setWinSize] = useState(null);
  const { width } = UseWindowSize();
  useEffect(() => {
    setWinSize(width);
    GACustomEvent("shop_in_store_page", "view");
  }, []);

  return (
    <Layout>
      <NextHead
        title={pageTitle}
        url={asPath}
        breadcrumb={breadcrumb}
        description={descriptionSEO}
      />
      <BreadcrumbComponent items={ShopOfflineBreadcrumb} />
      <BannerComponent
        img={winSize > 600 ? BannerImage : BannerMiniImage}
        visible
        mobileHeight="100%"
      ></BannerComponent>
      <ShopOffline dataOfflineShop={dataOfflineShop.data} />
      <SeoTextShopOffline />
    </Layout>
  );
};

belanjaDiToko.getInitialProps = async ({ asPath }) => {
  const pageTitle = belanjaDitokoMeta.title;
  const descriptionSEO = belanjaDitokoMeta.description;
  const dataOfflineShop = await fetchOfflineShop();
  return { asPath, pageTitle, descriptionSEO, dataOfflineShop };
};

export default belanjaDiToko;
